import { IconBaseProps } from 'react-icons';
import classNames from 'classnames';
import { RainMediumIcon } from 'app/agriculture/icons/RainMediumIcon';
import { RainSmallIcon } from 'app/agriculture/icons/RainSmallIcon';
import { RainLargeIcon } from 'app/agriculture/icons/RainLargeIcon';
import './DynamicRainIndicator.scss';

interface DynamicRainIndicatorProps extends IconBaseProps {
    rainfall?: number;
}

function getRainIcon(rainfall?: number) {
    if (rainfall === undefined) return RainMediumIcon;
    if (rainfall > 80) return RainLargeIcon;
    if (rainfall > 20) return RainMediumIcon;
    if (rainfall > 0) return RainSmallIcon;
    return RainMediumIcon;
}

export function DynamicRainIndicator({ rainfall, ...props }: DynamicRainIndicatorProps) {
    const Icon = getRainIcon(rainfall);

    return (
        <Icon
            {...props}
            className={classNames(
                'DynamicRainIndicator',
                props.className,
                (rainfall === 0 || rainfall === undefined) && 'DynamicRainIndicator__dry',
            )}
            title="Rainfall"
        />
    );
}
